import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P241List({ dataTable, setEditDialog, goPage }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (rowData) => setEditDialog({ data: rowData });

    const header = (
        <div className="table-header">
            <Button
                className="p-button p-button-success btn-hidden-responsive "
                label="เพิ่มการประเมินใหม่"
                icon="pi pi-plus"
                // onClick={() => setDialog({ dialog: true, action: 'บันทึก' })}
                onClick={() => goPage("242")}
            />
            <Button
                className="p-button-secondary p-button"
                icon="pi pi-arrow-left"
                label="ย้อนกลับ"
                // style={{ marginLeft: '5px' }}
                style={{ width: 170, marginLeft: "5px" }}
                onClick={() => goPage("B")}
            />
        </div>
    );

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    header={header}
                    rowsPerPageOptions={[5, 10, 25]}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="assessmentNo" header="ประเมินครั้งที่" body={(e) => normalColumn(e, "assessmentNo", "ประเมินครั้งที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="assessmentPeriod" header="ช่วงวันที่" body={(e) => normalColumn(e, "assessmentPeriod", "ช่วงวันที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="assessmentResult1" header="ผลแบบประเมินที่ 1" body={(e) => normalColumn(e, "assessmentResult1", "ผลแบบประเมินที่ 1")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="updateUserId" header="ผู้บันทึก" body={(e) => normalColumn(e, "updateUserId", "ผู้บันทึก")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="updateDt" header="วันที่-เวลาบันทึก" body={(e) => normalColumn(e, "updateDt", "วันที่-เวลาบันทึก")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="แก้ไข" field="photoPath" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
